import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../../images/Close.svg";
import { Button } from "../../../../../stories/Button/Button";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import {
  MaterialRequestStatus,
  Operation,
  TableHeaders,
} from "../../../../../utils/Enum.types";
import { Checkbox } from "@mui/material";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import SelectedSuppliers from "./SelectedSuppliers";
import { AppContext } from "./statesProvider/materialContext";
import { responseType } from "../../../../../utils/formTypes";
import { useLazyQuery } from "@apollo/client";
import { GetSuppliers } from "../../masters/supplier/queries/queries";
import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
  GetSuppliersResult,
  GetSuppliersVars,
  LdgrQueryType,
} from "../../masters/supplier/queries/types";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import { materialStatesPayloadTypes } from "./statesProvider/materialReducer";
import LoadingModal from "../../../../pages/LoadingModal";
import useLabels from "../../../../../customHooks/useLabels";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  value?: responseType[];
  handleItemSelect?: (newValue: responseType[]) => void;
}
const Assign = ({ setModalFlag, handleItemSelect, value }: Props) => {
  const { Purchase } = useAssetTableJson();
  const [assign, setAssign] = useState(false);



  const [message, setMessage] = useState(emptyMessage);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  const [searchSupplier, setSearchSupplier] = useState("");

  const [endCursor, setEndCursor] = useState<string | null>(null);

  const [rows, setRows] = useState<GridValidRowModel[]>([]);

  const { customer_id } = useUrlParams();

  const [selectedSuppliers, setSelectedSuppliers] = useState<responseType[]>(
    []
  );

  const [GetSupplierList, { data, loading, fetchMore }] = useLazyQuery<
    GetSuppliersResult,
    GetSuppliersVars
  >(GetSuppliers);

  const { state: materialState, dispatch: materialDispatch } =
    useContext(AppContext);

  const [suppliers, setSuppliers] = useState<AtsAcLdgrEdge[]>([]);

  const dynamicHeaders: TableHeaderProps[] = Purchase.Material.Assign.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
    })
  );

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSuppliers.edges;
              const pageInfo = fetchMoreResult.GetSuppliers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSuppliers.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSuppliers: {
                  edges: [...suppliers, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSuppliers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSuppliers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = suppliers.find(
            (supplier) => supplier.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSuppliers(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            supplier_name: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            mobile_no: node.supplier_details.phone,
            contact_person: node.supplier_details.contactPerson,
            supplier_id: node.id,
          }))
        );
      } else {
        setSuppliers(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            supplier_name: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            mobile_no: node.supplier_details.phone,
            contact_person: node.supplier_details.contactPerson,
            supplier_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetSuppliers.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  const supplierList = suppliers.map(({ node }, index) => ({
    id: index + 1,
    supplier_name: node.desc,
    gstNo: node.supplier_details.gstNo,
    city: node.supplier_details.city,
    state: node.supplier_details.state,
    proficiency: node.supplier_details.proficiency,
    mobile_no: node.supplier_details.phone,
    contact_person: node.supplier_details.contactPerson,
    supplier_id: node.id,
  }));
  const handleChecked = (supplier: any) => {
    const isExists = onlyIds.includes(supplier.supplier_id);

    if (isExists) {
      const filterSelectedSupplier = selectedSuppliers.filter(
        ({ value }) => value !== supplier.supplier_id
      );

      setSelectedSuppliers(filterSelectedSupplier);
    } else {
      setSelectedSuppliers([
        ...selectedSuppliers,
        {
          label: supplier.supplier_name,
          value: supplier.supplier_id,
        },
      ]);
    }
  };

  const onlyIds = selectedSuppliers.map((supplier) => supplier.value);

  const columns: GridColDef[] = [
    {
      field: "id",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      renderCell: (params) => {
        const checked = onlyIds.includes(params.row.supplier_id);
        return (
          <>
            <Checkbox
              checked={checked}
              onChange={(e) => {
                handleChecked(params.row);
              }}
            />
            {params.row.id}
          </>
        );
      },
      renderHeader: (params) => {
        return (
          <>
            <Checkbox /> {TableHeaders.SLNO}
          </>
        );
      },
    },
    ...dynamicHeaders,
  ];

  useEffect(() => {
    const fetchdata = async () => {
      if (customer_id) {
        GetSupplierList({
          variables: {
            after: null,
            customer_id,
            first: ROWS_PER_PAGE,
            name: searchSupplier,
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsAcLdgrOrderField.CREATED_AT,
            },
            
            input: {
              query_type: LdgrQueryType.ALL,
              itemID: 0,
              tableLevel: undefined,
            },
          },
        });
      }
    };
    fetchdata();
  }, [customer_id, GetSupplierList, searchSupplier]);

  useEffect(() => {
    if (value) {
      setSelectedSuppliers(value);
    } else setSelectedSuppliers(materialState.selectedSuppliers);
  }, [materialState.selectedSuppliers]);

  const handleAssign = () => {
    setAssign(true);
    materialDispatch({
      type: materialStatesPayloadTypes.SUPPLIERS,
      payload: {
        selectedSuppliers: selectedSuppliers,
      },
    });
  };

  const handleClose = () => {
    setAssign(!assign);
    setModalFlag(false);
  };
  const { itemLabel, ledgerLabel } = useLabels();
  return (
    <>
      <div className="material-assign">
        <div className="material-assign__title">
          <Title>
            Assign {ledgerLabel} for the {itemLabel} Quote
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
        </div>
        {materialState.itm ? (
          <div className="material-assign__flex">
            <b>{materialState.itm.label}</b>
            {materialState.itm.code ? (
              <span>( {materialState.itm.code} )</span>
            ) : null}
          </div>
        ) : null}
        <div className="material-assign__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={supplierList}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button
          mode="assign"
          onClick={() => {
            if (handleItemSelect) {
              handleItemSelect(selectedSuppliers);
            } else handleAssign();
            setAssign(!assign);
          }}
        >
          Suppliers
        </Button>
        <Button
          mode="cancel"
          onClick={() => {
            setModalFlag(false);
          }}
        />

        <CustomDrawer
          anchor="right"
          open={assign}
          onClose={() => setAssign(!assign)}
        >
          <SelectedSuppliers
            setModalFlag={setAssign}
            pageType={MaterialRequestStatus.APPROVED}
            handleClose={handleClose}
            value={value}
            handleItemSelect={handleItemSelect}
          />
        </CustomDrawer>
        <LoadingModal flag={loading} />
      </div>
    </>
  );
};

export default Assign;
